import { useEffect, useRef } from "react";

const genBolt = (x0, y0, x1, y1, disp) => {
  const pts = [[x0, y0]];
  const build = (ax, ay, bx, by, d) => {
    if (d < 10) {
      pts.push([bx, by]);
      return;
    }
    const mx = (ax + bx) / 2 + (Math.random() - 0.5) * d;
    const my = (ay + by) / 2 + (Math.random() - 0.5) * d * 0.5;
    build(ax, ay, mx, my, d / 2);
    build(mx, my, bx, by, d / 2);
  };
  build(x0, y0, x1, y1, disp);
  return pts;
};

const drawBolt = (ctx, pts, alpha) => {
  ctx.beginPath();
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.strokeStyle = `rgba(168, 85, 247, ${alpha * 0.35})`;
  ctx.lineWidth = 6;
  ctx.shadowColor = "#A855F7";
  ctx.shadowBlur = 26;
  ctx.stroke();
  ctx.strokeStyle = `rgba(233, 213, 255, ${alpha})`;
  ctx.lineWidth = 1.6;
  ctx.shadowBlur = 14;
  ctx.stroke();
};

export const Lightning = ({ className = "", interval = [2200, 5200] }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let bolts = [];
    let raf;
    let timer;
    let stopped = false;

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
      ctx.setTransform(window.devicePixelRatio, 0, 0, window.devicePixelRatio, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const strike = () => {
      if (stopped) return;
      const w = canvas.offsetWidth;
      const h = canvas.offsetHeight;
      const x0 = w * (0.1 + Math.random() * 0.8);
      const x1 = x0 + (Math.random() - 0.5) * w * 0.25;
      const y1 = h * (0.45 + Math.random() * 0.45);
      const main = genBolt(x0, -10, x1, y1, Math.min(w, 300));
      bolts.push({ pts: main, life: 1 });
      const mid = main[Math.floor(main.length * (0.3 + Math.random() * 0.3))];
      if (mid) {
        bolts.push({
          pts: genBolt(mid[0], mid[1], mid[0] + (Math.random() - 0.5) * w * 0.3, mid[1] + h * 0.2, 120),
          life: 0.8,
        });
      }
      timer = setTimeout(strike, interval[0] + Math.random() * (interval[1] - interval[0]));
    };

    const loop = () => {
      ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
      bolts.forEach((b) => {
        drawBolt(ctx, b.pts, Math.max(b.life, 0));
        b.life -= 0.035;
      });
      bolts = bolts.filter((b) => b.life > 0);
      raf = requestAnimationFrame(loop);
    };

    timer = setTimeout(strike, 700);
    loop();

    return () => {
      stopped = true;
      clearTimeout(timer);
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [interval]);

  return <canvas ref={canvasRef} className={className} data-testid="lightning-canvas" aria-hidden="true" />;
};
